import { adoptedStyleSheetsSupport } from "@otto-ec/otto-components-utils/utils/canIUse";
import { runtimeScope } from "./logger";

const log = runtimeScope.scope("shadow-styles-injector");

/**
 *
 *
 *
 *
 *
 */
export type ShadowStylesInjector = (element: HTMLElement) => Promise<void>;

/**
 *
 *
 *
 */
export type LazyStyleModuleImport = () => Promise<typeof import("*?inline")>;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
const injectShadowStyles = (
  rootNode: ShadowRoot,
  styleSheet: CSSStyleSheet | undefined,
  css: typeof import("*?inline"),
): CSSStyleSheet | undefined => {
  let style = styleSheet;

  /*                                                                            */
  /*                                                              */
  try {
    if (adoptedStyleSheetsSupport) {
      /*                                                                                                                */
      if (!style) {
        style = new CSSStyleSheet();
        /*                                                                           */
        style.replace(css.default);
      }

      rootNode.adoptedStyleSheets.push(style);
      return style;
    }
  } catch (error) {
    log.warn("Error injecting shadow styles:", error);
  }

  /*                                                            */
  /*                        */
  const styleEl = document.createElement("style");
  styleEl.textContent = css.default;
  rootNode.appendChild(styleEl);
  return undefined;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useShadowStylesInjector: (
  styles?: LazyStyleModuleImport | undefined,
) => ShadowStylesInjector = (styles) => {
  /**
 *
 *
 */
  const adoptedRoots = new WeakSet<ShadowRoot>();
  /**
 *
 *
 */
  let styleSheet: CSSStyleSheet | undefined;

  return async (element) => {
    if (!styles) return;

    const rootNode = element.getRootNode();

    /*                                                                */
    if (!(rootNode instanceof ShadowRoot) || adoptedRoots.has(rootNode)) return;

    /*                                                            */
    const css = await styles();

    styleSheet = injectShadowStyles(rootNode, styleSheet, css);

    /*                                                                               */
    adoptedRoots.add(rootNode);
  };
};
